import React, { useEffect, useState } from 'react';
import Title from '../../components/Title';
import SearchBar from '../../components/SearchBar';
import Character from '../../components/Character';
import getWishlist from '../../packages/api/getWishlist';
import Loading from '../../components/Loading';
import scrollToTop from '../../utils/scrollToTop';
import filterVillagerList from './filterVillagers';
import getVillagers from '../../packages/api/getVillagers';

const Search = () => {
  // const [listings, setListings] = useState([]);
  const [villagers, setVillagers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filteredList, setFilteredList] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    scrollToTop();
    const fetchData = async () => {
      // const list = await getListings();
      const v = await getVillagers();
      const theWishlist = await getWishlist();
      setWishlist(theWishlist);
      setVillagers(v);
      setFilteredList(v)
      if (Array.isArray(v)) {
        setVillagers(v);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (event) => {
    setInputValue(event.target.value);
    filterVillagerList(setFilteredList, villagers, event);
  };

  if (isLoading) return <Loading />;

  return (
    <>
      <Title>Rechercher</Title>

      <SearchBar
        placeholder=""
        handleChange={handleChange}
        inputValue={inputValue}
        testId="search-input"
      />
      {filteredList.map((villager) => {
        const { image, name } = villager;
        const includeName = wishlist.some(v => v._id == villager._id);
        return (
          <Character
            key={villager._id}
            villagerId={villager._id}
            name={name.fr}
            image={image}
            liked={includeName}
          />
        );
      })}
    </>
  );
};

export default Search;
